import { storageKeys } from 'config/settings.json';
import StorageHandler from 'config/StorageHandler';

// Single source of truth: add new flags here when introduced. Known keys are always present in the returned object (default false).
const FEATURE_FLAG_NAMES = [
  'has_achievements_rewards_page',
  'ambassador',
  'badges',
  'button_bar_directory',
  'directory',
  'enable_advisor_dashboard',
  'enable_advisor_dashboard_light_theme',
  'enable_advisor_dashboard_right',
  'en_gb_default_language',
  'eu_servers',
  'light_icons',
  'metallic_tiers',
  'points_based_rewards',
  'rewards',
  'rewards_booking',
  'rewards_graduation_required',
  'showcases',
  'smart_assist',
  'solid_icons',
  'titles_to_bold',
  'titles_to_capitalize',
  'titles_to_uppercase',
  'white_home_logo',
  'wide_home_logo',
  'has_color_header_logo',
  'is_booking_dashboard_disabled',
  'enable_region_lock_na_rewards',
  'enable_fast_track',
  'enableDirectoryHeaderCompatibilityFix',
  'disabled_image_share',
  'show_image_license_notice',
  'space_in_supposed_empty_line',
] as const;

export type FeatureFlagName = (typeof FEATURE_FLAG_NAMES)[number];

// Known flags are always present (default false); unknown flags from the API are also allowed.
export type FeatureFlags = Record<FeatureFlagName, boolean> & Record<string, boolean>;

interface FeatureFlagItem {
  name: string;
  is_enabled: boolean;
}

// TODO: Export to an app-wide type as part of a StorageHandler rework.
interface AppInfo {
  featureFlags?: FeatureFlagItem[];
}

// Loads feature flags from appInfo in storage. Known flags default to false; API values override. Unknown flags from the API are also set.
const getFeatureFlags = async (): Promise<FeatureFlags> => {
  const appInfo = (await StorageHandler.load(storageKeys.appInfo)) as AppInfo | undefined;

  const flags = Object.fromEntries(FEATURE_FLAG_NAMES.map((name) => [name, false])) as FeatureFlags;

  const featureFlagsList = appInfo?.featureFlags;
  if (featureFlagsList && featureFlagsList.length > 0) {
    featureFlagsList.forEach((feature) => {
      flags[feature.name] = feature.is_enabled;
    });
  }

  return flags;
};

export default getFeatureFlags;
